import { del, get, post, put, urlApiTegra } from "../../../service/api";

export const getProfiles = async (token: string): Promise<any> => {
  return get(`${urlApiTegra}/profiles`, token);
};

export const getProfileById = ({ token, id }: { token: string; id: number | string }) => {
  return get(`${urlApiTegra}/profile-access/${id}`, token);
};

export const postProfile = async ({ token, body }: { token: string; body: any }) => {
  return post(`${urlApiTegra}/profile-access`, body, token);
};

export const updateProfile = async ({ token, body, id }: { token: string; body: any; id: number }) => {
  return put(`${urlApiTegra}/profile-access/${id}`, body, token);
};

export const deleteProfile = async ({ token, id }: { token: string; id: number }) => {
  return del(`${urlApiTegra}/profile-access/${id}`, token);
};
